export default {
  widgets: {
    analyticsApplications: {
      title: 'Количество заявок',
      select: {
        labels: {
          source: 'Источник',
          store: 'Магазин',
          consultant: 'Консультант',
          applicationStatus: 'Статус заявки',
          month: 'Месяц',
          year: 'Год',
        },
        options: {
          loading: 'Загружается...',
          all: 'Все',
          months: [
            '',
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
          ],
        },
        titles: {
          choose: 'Выберите значение',
          consultant: 'Консультант',
          store: 'Введите название магазина',
        },
      },
      applicationsSum: 'Сумма заявок',
      applicationsCount: 'Количество заявок',
      errors: {
        noData: 'По данному запросу ничего не найдено',
      },
      radio: {
        labels: {
          sum: 'Сумма',
          count: 'Количество',
        },
      },
      tabs: {
        applications: 'Заявки',
        monthly: 'За месяц',
        yearly: 'За год',
      },
    },
  },
};
